import { useEffect } from "react";
import { useLocation } from "react-router";

// Space for the sticky header when landing on a section.
const HEADER_OFFSET = 90;
// How long to wait for a #section to appear (pages render after the route loads).
const HASH_WAIT_MS = 4000;

const ScrollToTop = ({ children }) => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const id = decodeURIComponent((hash || "").slice(1));
    if (!id) {
      window.scrollTo(0, 0);
      return undefined;
    }

    // Links like /api-integrations#contact (e.g. from emails): the browser's own
    // jump runs before React renders the section, so wait for it, then scroll.
    let cancelled = false;
    const started = Date.now();
    const tryScroll = () => {
      if (cancelled) return;
      const el = document.getElementById(id);
      if (el) {
        const top = el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
        window.scrollTo({ top: Math.max(top, 0), behavior: "smooth" });
        return;
      }
      if (Date.now() - started < HASH_WAIT_MS) {
        timer = setTimeout(tryScroll, 100);
      }
    };
    let timer = setTimeout(tryScroll, 0);

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [pathname, hash]);

  return children || null;
};

export default ScrollToTop;
